export default __webpack_public_path__ + "static/oberon-travelbase-ds-2-f2d21b3e6528b5f9b65b5a60a3909d41.jpg";